'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('../propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/href-no-hash:0 */

function PreviewLink(_ref) {
  var navigationItem = _ref.navigationItem;

  if (navigationItem.navigation_section_id) {
    return _react2.default.createElement(
      'a',
      { className: 'dropdown-item', href: '#' },
      navigationItem.title
    );
  }

  return _react2.default.createElement(
    'a',
    { className: 'nav-item nav-link', href: '#' },
    navigationItem.title
  );
}

PreviewLink.propTypes = {
  navigationItem: _propTypes.NavigationItemPropType.isRequired
};

exports.default = PreviewLink;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/PreviewLink.js
// module id = 207
// module chunks = 0